export default __webpack_public_path__ + "b453d4cc5950161c8e8776db9ee01e35.png";